import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { prepareHeaders } from 'utils';

const QuickBooksCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');
    let state = query.get('state'); // Get state (user_id) from the URL
    const realmId = query.get('realmId'); // Get realmId from the URL

    // Attempt to retrieve state from sessionStorage if it's missing in the query params
    if (!state) {
      state = sessionStorage.getItem('quickbooks_state');
    }

    if (!state) {
      console.error('State missing from both query params and sessionStorage');
      return; // Handle the missing state case here
    }

    // Convert the state (user_id) to a string before sending it to the backend
    const stateAsString = state.toString();

    const sendCodeToBackend = async () => {
      const headers = await prepareHeaders(new Headers());
      headers.append('Accept', '*/*');
      headers.append('Content-Type', 'application/json');

      if (code && stateAsString && realmId) {
        try {
          // Make a POST request to the backend with the code and state as a string
          const response = await fetch(
            `${process.env.REACT_APP_API_URL}/quick_books/callback`,
            {
              method: 'POST',
              headers,
              body: JSON.stringify({ code, state: stateAsString, realmId }),
            },
          );

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();
          if (data.message) {
            // Success: Handle post-authentication steps, e.g., navigate to the dashboard
            console.log('QuickBooks connected successfully:', data.message);
            navigate('/dashboard'); // Redirect to the dashboard or another page
          } else {
            console.error('QuickBooks connection failed:', data.error);
          }
        } catch (error) {
          console.error('Error handling QuickBooks callback:', error);
        }
      } else {
        console.error('Missing code or state parameter or realmid');
      }
    };

    sendCodeToBackend();
  }, [location.search, navigate]);

  return <div>Loading...</div>;
};

export default QuickBooksCallback;
